export const SUBTRACT_SELECT_ALL = 'SUBTRACT_SELECT_ALL';
export const ADD_SELECT_ALL = 'ADD_SELECT_ALL';
export const ADD_ROLES_COUNT = 'ADD_ROLES_COUNT';
export const SUBTRACT_ROLES_COUNT = 'SUBTRACT_ROLES_COUNT';
